import config from 'js/app/config';
import type UserAgent from 'js/lib/useragent';

import { deepLinkablePages } from 'bundles/page-header/components/mobile/constants';

const ANDROID_APP_ID = 'org.coursera.android';
const ANDROID_STORE_BASE_URL = 'http://play.google.com/store/apps/details?id=';
const ANDROID_STORE_BASE_URL_CHINA = 'http://android.myapp.com/myapp/detail.htm?apkName=';

const STORE_URL = {
  // REF https://linkmaker.itunes.apple.com/us/
  ios: 'https://itunes.apple.com/app/apple-store/id736535961?pt=2334150&ct=Coursera%20Web%20Promo%20Banner&mt=8',

  // REF http://developer.android.com/distribute/tools/promote/linking.html
  android: ANDROID_STORE_BASE_URL + ANDROID_APP_ID,
  androidChina: ANDROID_STORE_BASE_URL_CHINA + ANDROID_APP_ID,
};

function shouldAvoidGooglePlay(requestCountryCode = config.requestCountryCode) {
  // Google Play is blocked in China
  return requestCountryCode === 'CN';
}

function storeForAgent(userAgent?: UserAgent, requestCountryCode = config.requestCountryCode) {
  if (!userAgent) {
    return null;
  }

  if (userAgent.isIOS) {
    return 'ios';
  } else if (userAgent.isAndroid) {
    if (shouldAvoidGooglePlay(requestCountryCode)) {
      return 'androidChina';
    } else {
      return 'android';
    }
  }
}

function getAppUrl(userAgent?: UserAgent, urlPath = '/browse', requestCountryCode = config.requestCountryCode) {
  if (!userAgent) {
    return null;
  }

  const storeType = storeForAgent(userAgent, requestCountryCode);
  if (!storeType) {
    return null;
  }

  if (storeType === 'ios') {
    return STORE_URL[storeType];
  }

  const matchedPage = deepLinkablePages.find((pageConfig) => pageConfig.pattern.test(urlPath));
  const androidPath = matchedPage ? matchedPage.webToMobilePathTranslator(urlPath) : '/browse';

  if (storeType === 'androidChina') {
    const encodedPlayStoreUrl = encodeURIComponent(STORE_URL[storeType]);
    return `intent:coursera-mobile://app${androidPath}#Intent;package=org.coursera.android;S.browser_fallback_url=${encodedPlayStoreUrl};end;`;
  } else {
    return `intent:coursera-mobile://app${androidPath}#Intent;package=org.coursera.android;end;`;
  }
}

const exported = {
  shouldAvoidGooglePlay,
  storeForAgent,
  storeUrls: STORE_URL,

  // FROM https://docs.google.com/a/coursera.org/document/d/1Rg-Km5A5tN2wzhv-pv3gKIB2gvghm8goX3UcUHOhR7s/edit
  getAppUrl,
};

export default exported;
export { shouldAvoidGooglePlay, storeForAgent, STORE_URL as storeUrls, getAppUrl };
